import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { confirmAlert } from 'react-confirm-alert';
import { Card } from "antd";
import 'react-confirm-alert/src/react-confirm-alert.css';

import AdapterRegister from 'components/adapter/list/AdapterRegister';
import AdapterSetting from 'components/adapter/list/AdapterSetting';
import AdapterUpdate from 'components/adapter/list/AdapterUpdate';
import * as types from 'reducer/actionTypes';

class AdapterList extends React.Component {
	componentWillMount(){
		this.props.fetchAdapterList()
	}

	onClickDelete = (t, adapterName) => {
		confirmAlert({
			title: t('ac.confirm.label.delete.confirm'),
			message: t('ac.confirm.label.delete.body'),
			buttons: [
				{
					label: t('confirm.box.yes'),
					onClick: () => this.props.fetchAdapterUnregister(adapterName)
				},
				{
					label: t('confirm.box.no'),
				}
			]
		});
	}
	
	render(){
		const {t} = this.props;

		const TableRow = ((data) => {
			return (
				<tr>
					<td>{data.adapter.adapter}</td>
					<td>{data.adapter.description}</td>
					<td>{data.adapter.author}</td>
					
					<td className="adapter_state">
						{data.adapter.state==true ? t('ac.table.label.running') : t('ac.table.label.stopped')}
						&nbsp;&nbsp;
						<div className={data.adapter.state ? "icon_adapter_start disable" : "icon_adapter_start"} title={t('ac.table.label.run')}
						onClick={() => this.props.fetchAdapterEnable(data.adapter.adapter,true)}></div>
						<div className={data.adapter.state ? "icon_adapter_stop" : "icon_adapter_stop disable"} title={t('ac.table.label.stop')}
						onClick={() => this.props.fetchAdapterEnable(data.adapter.adapter,false)}></div>
					</td>

					<td>
						<div className="icon_adapter_setting" title={t('ac.table.label.settings')} onClick={() => this.props.fetchAdapterSetting(data.adapter.adapter)}></div>
						<div className="icon_adapter_update" title={t('ac.table.label.update')} onClick={() => this.props.setAdapterUpdateModal(data.adapter)}></div>
						<div className="icon_adapter_delete" title={t('ac.table.label.delete')} onClick={() => this.onClickDelete(t, data.adapter.adapter)}></div>
					</td>
				</tr>
			)
		})

		return(
			<div style={{margin:"10px"}}>
				<div className="stl">
					<button className="btn_text_b icon_btn" onClick={this.props.setAdapterRegisterModal}><span className="icon_add"></span>{t('aa.text.label.title')}</button>
				</div>
				<div className="content_box">
					<table className="adapter_table">
						<colgroup>
							<col width="127px"/>
							<col />
							<col />
							<col width="150px"/>
							<col width="150px"/>
						</colgroup>
						<thead>
							<tr>
								<th>{t('ac.table.label.adapter')}</th>
								<th>{t('ac.table.label.description')}</th>
								<th>{t('ac.table.label.author')}</th>
								<th>{t('ac.table.label.state')}</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.props.adapterList.map((data,i)=> {
								return(
								<TableRow
									key={i}
									adapter={data}/>
								)
							})}
						</tbody>
					</table>
					</div>
				<AdapterRegister/>
				<AdapterSetting/>
				<AdapterUpdate/>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		error: reducers.adapter.error,
		adapterList: reducers.adapter.adapterList,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setAdapterRegisterModal: () => {dispatch({type: types.SET_ADAPTER_REGISTER_MODAL})},
		setAdapterUpdateModal: (value) => {dispatch({type: types.SET_ADAPTER_UPDATE_MODAL, data:value})},
		
		fetchAdapterList: () => {dispatch({type: types.FETCH_GET_ADAPTER_LIST_REQUEST})},
		fetchAdapterSetting: (value) => {dispatch({type: types.FETCH_GET_ADAPTER_SETTING_REQUEST, adapter:value})},
		fetchAdapterEnable: (value,state) => {dispatch({type: types.FETCH_SET_ADAPTER_ENABLE_REQUEST, adapter:value, state:state})},
		fetchAdapterUnregister: (value) => {dispatch({type: types.FETCH_SET_ADAPTER_UNREGISTER_REQUEST, adapter:value})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AdapterList))